import { AppDispatch } from '../index';
import API from '@/app/lib/axios';
import { urls } from '../urls';
import { toast } from 'react-toastify';
import { DriverSlice } from '../controllers/DriverSlice';
import { DriverSettings } from '@/shared/models/driver.model';
import { GridURLParam } from '@/shared/models/grid.model';
import { parseURLParam } from '@/shared/helpers/gridData';
import { UserCreate } from '@/shared/models/user.model';
import { RootState } from '../index';

export const loadDrivers = (params?: GridURLParam | null) => async (dispatch: AppDispatch, getState: () => RootState) => {
  const { isLoadingDrivers } = getState().driver;
  if (isLoadingDrivers) return;
  try {
    dispatch(DriverSlice.actions.setLoadingDrivers(true));

    let URL = urls.loadDrivers;
    if (params) {
      params.limit = '500';
    } else {
      params = {
        limit: '500'
      };
    }
    if (params && Object.keys(params).length !== 0) {
      URL += parseURLParam(params);
    }

    const response: any = await API.get(`${URL}`);
    dispatch(DriverSlice.actions.loadDrivers(response));

    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Drivers: ${err}`);
  } finally {
    dispatch(DriverSlice.actions.setLoadingDrivers(false));
    dispatch(DriverSlice.actions.setRefreshData(false));
  }
};

export const loadSettingsDrivers = (params?: GridURLParam | null) => async (dispatch: AppDispatch) => {
  try {
    dispatch(DriverSlice.actions.setLoadingDrivers(true));

    let URL = urls.loadSettingsDrivers;

    if (params && Object.keys(params).length !== 0) {
      URL += parseURLParam(params);
    }

    const response: any = await API.get(`${URL}`);
    dispatch(DriverSlice.actions.loadDrivers(response));

    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Drivers: ${err}`);
  } finally {
    dispatch(DriverSlice.actions.setLoadingDrivers(false));
    dispatch(DriverSlice.actions.setRefreshData(false));
  }
};

export const createDriver = (data: DriverSettings) => async () => {
  try {
    const URL = urls.drivers;
    const response: any = await API.post(`${URL}`, data);
    return response;
  } catch (err: any) {
    toast(`${err}`);
    console.error(`Error upon Driver Creating: ${err}`);
  }
};

export const createUserDriver = (data: {user: UserCreate, driver: DriverSettings}) => async () => {
  try {
    const URL = urls.createUserDriver;
    const response: any = await API.post(`${URL}`, data);
    return response;
  } catch (err: any) {
    toast(`${err}`);
    console.error(`Error upon Driver Creating: ${err}`);
    throw err;
  }
};

export const updateDriver = (driverId: string, data: DriverSettings) => async () => {
  const config = {
    allowedErrorStatus: 404,
  } as any;
  try {
    const URL = urls.driverById.replace(':id', driverId);
    const response: any = await API.patch(`${URL}`, data, config);
    return response;
  } catch (err: any) {
    toast(`${err}`);
    console.error(`Error upon Driver update: ${err}`);
    throw err;
  }
};

export const sendInvite = (id: number) => async () => {
  try {
    const URL = urls.driverInvite.replace(':id', `${id}`);
    const response: any = await API.post(`${URL}`);
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Sending Invite: ${err}`);
  }
};

export const loadTerminals = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(DriverSlice.actions.setLoadingTerminals(true));
    const URL = urls.terminals;
    const response: any = await API.get(`${URL}`);
    dispatch(DriverSlice.actions.loadTerminals(response));
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Terminals: ${err}`);
  } finally {
    dispatch(DriverSlice.actions.setLoadingTerminals(false));
  }
};

export const loadDriverGroups = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(DriverSlice.actions.setLoadingDriverGroups(true));

    const URL = urls.driverGroups;
    const response: any = await API.get(`${URL}`);
    dispatch(DriverSlice.actions.loadDriverGroups(response));
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Driver Groups: ${err}`);
  } finally {
    dispatch(DriverSlice.actions.setLoadingDriverGroups(false));
  }
};

export const loadHosRules = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(DriverSlice.actions.setLoadingHosRules(true));

    const URL = urls.hosRules;
    const response: any = await API.get(`${URL}`);
    dispatch(DriverSlice.actions.loadHosRules(response));
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Hos Rules: ${err}`);
  } finally {
    dispatch(DriverSlice.actions.setLoadingHosRules(false));
  }
};

export const loadCargoType = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(DriverSlice.actions.setLoadingCargoType(true));

    const URL = urls.cargoTypes;
    const response: any = await API.get(`${URL}`);
    dispatch(DriverSlice.actions.loadCargoType(response));
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Cargo Type: ${err}`);
  } finally {
    dispatch(DriverSlice.actions.setLoadingCargoType(false));
  }
};

export const loadRestart = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(DriverSlice.actions.setLoadingRestart(true));
    const URL = urls.restarts;
    const response: any = await API.get(`${URL}`);
    dispatch(DriverSlice.actions.loadRestart(response));
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Restart: ${err}`);
  } finally {
    dispatch(DriverSlice.actions.setLoadingRestart(false));
  }
};

export const loadRestBreak = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(DriverSlice.actions.setLoadingRestBreak(true));
    const URL = urls.restBreaks;
    const response: any = await API.get(`${URL}`);
    dispatch(DriverSlice.actions.loadRestBreak(response));
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Rest Break: ${err}`);
  } finally {
    dispatch(DriverSlice.actions.setLoadingRestBreak(false));
  }
};

export const driverById = (id: string) => async () => {
  try {
    const URL = urls.driverById.replace(':id', `${id}`);
    const response: any = await API.get(`${URL}`);
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Driver By Id: ${err}`);
  }
};

export const driverLatestStatusById = (id: string) => async () => {
  try {
    const URL = urls.driverLatestStatusById.replace(':id', `${id}`);
    const response: any = await API.get(`${URL}`);
    return response;
  } catch (err: any) {
    console.error(`Error upon Getting Driver By Id: ${err}`);
    return null;
  }
};

export const driverActivate = (id: string) => async () => {
  try {
    const URL = urls.driverActivate.replace(':id', `${id}`);
    const response: any = await API.post(`${URL}`);
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Activating Driver By Id: ${err}`);
  }
};

export const driverDeactivate = (id: string) => async () => {
  try {
    const URL = urls.driverDeactivate.replace(':id', `${id}`);
    const response: any = await API.delete(`${URL}`);
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Deactivating Driver By Id: ${err}`);
  }
};

export const loadDriverRecap = (params: any) => async () => {
  try {
    const response: any = await API.get(urls.driverLogRecap, {params: params});
    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Drivers: ${err}`);
  }
};

export const loadTimeRegulations = () => async (dispatch: AppDispatch) => {
  const cachedData = localStorage.getItem('timeRegulations');
  if (cachedData) {
    return JSON.parse(cachedData);
  }
  try {
    let URL = urls.timeRegulations;
    const response: any = await API.get(URL);
    dispatch(DriverSlice.actions.loadTimeRegulations(response));
    localStorage.setItem('timeRegulations', JSON.stringify(response));
    return response;
  } catch (err: any) {
    console.log(`Fetch time regulations error: ${err}`);
  }
};

export const loadCurrentCoDriver = (driverId: any) => async () => {
  try {
    const URL = urls.currentCoDriver.replace(':driver_id', `${driverId}`);
    const response: any = await API.get(URL);

    return response;
  } catch (err: any) {
    toast(`${err.message}`);
    console.error(`Error upon Getting Drivers: ${err}`);
  }
};

export type DriverDoc = {
  id: number;
  externalId: string;
  provider: string;
  created_at: string;
  hos_event: number;
  driver: number;
  company: number;
  url: string;
};

export const loadDocuments = (driverId: any) => async (dispatch: AppDispatch) => {
  try {
    const URL = urls.shippingDocs.replace(':id', driverId);
    const response: DriverDoc[] = await API.get(URL);
    dispatch(DriverSlice.actions.loadDocuments(response));

    return response;
  } catch (err: any) {
    console.error(`Error fetching shipping docs: ${err}`);
  }
};